<template>
  <div class="row">
    <div :class="['col_12', {'loading_overlay': loading}]">
      <div class="card no_border">
        <div class="card-header">
          <div class="d_flex_btwn form_action_btn width_full">
            <div class="card-title">{{ $t('sidebar.unitManagement.unit_creation') }}</div>
            <router-link class="btn btn_blue ml_10" :to="{name: cancelRouteName}">{{ $t('common.back') }}</router-link>
          </div>

        </div>
        <div class="card-body pl_0 pr_0">
          <div class="row">
            <div class="col_3">
              <div :class="['form-group', {'has_error': errorFor('subject_id')}]">
                <label>{{ $t('common.subject') }}</label>
                <select v-model="form.subject_id" class="form_global">
                  <option value="">{{ $t('common.select_subject') }}</option>
                  <option :value="subject.id" v-for="subject in subjects" :key="'subject_'+subject.id">{{ subject.name }}</option>
                </select>
                <v-errors :errors="errorFor('subject_id')" />
              </div>
            </div>

            <div class="col_3">
              <div :class="['form-group', {'has_error': errorFor('area_id')}]">
                <label>{{ $t('common.area') }}</label>
                <select v-model="form.area_id" class="form_global">
                  <option value="">{{ $t('common.select_area') }}</option>
                  <option :value="area.id" v-for="area in areas" :key="'area_'+area.id">{{ area.name }}</option>
                </select>
                <v-errors :errors="errorFor('area_id')" />
              </div>
            </div>
            <div class="col_3">
              <div :class="['form-group', {'has_error': errorFor('text_book_id')}]">
                <label>{{ $t('common.textBook') }}</label>
                <select v-model="form.text_book_id" class="form_global">
                  <option value="">{{ $t('common.select_textbook') }}</option>
                  <option :value="textbook.id" v-for="textbook in textbooks" :key="'textbook '+textbook.id">{{ textbook.name }}</option>
                </select>
                <v-errors :errors="errorFor('text_book_id')" />
              </div>
            </div>
            <div class="col_3">
              <div :class="['form-group', {'has_error': errorFor('grade')}]">
                <label>{{ $t('common.grade') }}</label>
                <select class="form_global" id="grade" v-model="form.grade_id">
                  <option value="">{{ $t('common.select') }}</option>
                  <option :value="grade.id" v-for="grade in grades" :key="'grade '+grade.id">{{ grade.name }}</option>
                </select>
                <v-errors :errors="errorFor('grade')"></v-errors>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col_3">
              <div :class="['form-group', {'has_error': errorFor('semester_id')}]">
                <label>{{ $t('common.semester') }}</label>
                <select v-model="form.semester_id" class="form_global">
                  <option value="">{{ $t('common.select_semester') }}</option>
                  <option :value="semester.id" v-for="semester in semesters" :key="'semester '+semester.id">{{ semester.name }}</option>
                </select>
                <v-errors :errors="errorFor('semester_id')" />
              </div>
            </div>
            <div class="col_3">
              <div :class="['form-group', {'has_error': errorFor('parking_id')}]">
                <label>{{ $t('common.parking') }}</label>
                <select v-model="form.parking_id" class="form_global">
                  <option value="">{{ $t('common.select_parking') }}</option>
                  <option :value="parking.id" v-for="parking in parkings" :key="'parking '+parking.id">{{ parking.name }}</option>
                </select>
                <v-errors :errors="errorFor('parking_id')" />
              </div>
            </div>
            <div class="col_3">
              <div :class="['form-group', {'has_error': errorFor('unit_name')}]">
                <label>{{ $t('sidebar.unitManagement.unit_name') }}</label>
                <input type="text" class="form_global" v-model="form.unit_name">
                <v-errors :errors="errorFor('unit_name')" />
              </div>
            </div>
            <div class="col_3">
              <div :class="['form-group', {'has_error': errorFor('keywords')}]">
                <label>{{ $t('sidebar.unitManagement.key_registration') }}</label>
                <input type="text" class="form_global" v-model="form.keywords">
                <v-errors :errors="errorFor('keywords')" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col_3">
              <div :class="['form-group', {'has_error': errorFor('scope')}]">
                <label>{{ $t('sidebar.unitManagement.scope') }}</label>
                <select class="form_global" id="scope" v-model="form.scope">
                  <option value="">{{ $t('common.select') }}</option>
                  <option value="one">*</option>
                  <option value="two">**</option>
                  <option value="three">***</option>
                  <option value="four">****</option>
                  <option value="five">*****</option>
                </select>
                <v-errors :errors="errorFor('scope')" />
              </div>
            </div>
            <div class="col_3">
              <div :class="['form-group', {'has_error': errorFor('status')}]">
                <label>{{ $t('common.status') }}</label>
                <div class="form_inline">
                  <div class="form_radio">
                    <input type="radio" id="waiting" value="1" v-model="form.status">
                    <label for="waiting">{{ $t('common.active') }}</label>
                  </div>
                  <div class="form_radio">
                    <input type="radio" id="posting" value="0" v-model="form.status">
                    <label for="posting">{{ $t('common.inactive') }}</label>
                  </div>
                </div>
                <v-errors :errors="errorFor('status')" />
              </div>
            </div>
          </div>

          <div class="row">
            <template v-for="(carCity, carCityIndex) in form.car_cities" :key="'car_city' + carCityIndex">
              <div class="col_10">
                <div :class="['form-group', {'has_error': errorFor('car_cities.' + carCityIndex)}]">
                  <label v-if="carCityIndex == 0">{{ $t('sidebar.unitManagement.car_city') }}</label>
                  <label v-else>{{ $t('sidebar.unitManagement.car_city') + '_' + carCityIndex }} </label>
                  <input type="text" class="form_global" v-model="form.car_cities[carCityIndex].city_name">
                  <v-errors :errors="errorFor('car_cities')" />
                </div>
              </div>
              <div class="col_2">
                <div class="form-group">
                  <label></label>
                  <div class="d_flex_end" v-if="carCityIndex == 0">
                    <button class="btn btn_blue" @click.prevent="addNewCity()">{{ $t('common.add') }}</button>
                  </div>
                  <div class="d_flex_end" v-else>
                    <button class="btn btn_blue mr_5" @click.prevent="addNewCity()">{{ $t('common.add') }}</button>
                    <button class="btn btn_danger" @click.prevent="removeCity(carCityIndex)">{{ $t('remove') }}</button>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <div class="row">
            <div class="col_12">
              <div :class="['form-group', {'has_error': errorFor('unit_goal')}]">
                <label>{{ $t('sidebar.unitManagement.unit_goal') }}</label>
                <textarea rows="7" cols="50" class="form_global" v-model="form.unit_goal"></textarea>
                <v-errors :errors="errorFor('unit_goal')" />
              </div>
            </div>
          </div>


          <div class="d_flex_end form_action_btn">
            <router-link class="btn btn_danger ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
            <button class="btn btn_blue ml_10" @click.prevent="submit">{{ $t('common.save') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: this.$t('sidebar.unitManagement.unit_creation'),
      cancelRouteName: 'unit_registration_list',
      subjects: [],
      areas: [],
      grades: [],
      textbooks: [],
      semesters: [],
      parkings: [],
      form: {
        subject_id: '',
        area_id: '',
        text_book_id: '',
        grade_id: '',
        semester_id: '',
        parking_id: '',
        unit_name: '',
        car_cities: [
          {
            city_name : ''
          }
        ],
        unit_goal: '',
        keywords: '',
        scope: '',
        status: '1'
      },
    }
  },
  created() {
    this.axios.get('/subjects').then((response) => this.subjects = response.data.data);

    this.axios.get('/areas').then((response) => this.areas = response.data.data);

    this.axios.get('/parkings').then((response) => this.parkings = response.data.data);

    this.axios.get('/text-books').then((response) => this.textbooks = response.data.data);
    this.axios.get('/grades').then((response) => this.grades = response.data.data);

    this.axios.get('/semesters').then((response) => this.semesters = response.data.data);

    if (this.$route.name === 'unit_registration_edit') {
      this.axios.get('/units/'+this.$route.params.id)
          .then((response) => {
            let editUnitData = response.data.data;

            this.form.subject_id = editUnitData.subject ? editUnitData.subject.id : '';
            this.form.area_id = editUnitData.area ? editUnitData.area.id : '';
            this.form.text_book_id = editUnitData.textbook ? editUnitData.textbook.id : '';
            this.form.grade_id = editUnitData.grade ? editUnitData.grade.id : ''
            this.form.semester_id = editUnitData.semester ? editUnitData.semester.id : '';
            this.form.parking_id = editUnitData.parking ? editUnitData.parking.id : '';
            this.form.unit_name = editUnitData.unit_name
            this.form.unit_goal = editUnitData.unit_goal
            this.form.keywords = editUnitData.keywords
            this.form.scope = editUnitData.scope
            this.form.status = editUnitData.status

            if(editUnitData.carcity.length > 0){
              this.form.car_cities = [];

              editUnitData.carcity.forEach(city => {
                let carCityName = {
                  city_name: city.name,
                }
                this.form.car_cities.push(carCityName)
              })
            }
          })
      this.title = 'Edit Unit';
    }
  },
  methods: {
    addNewCity(){
      let city = {
        city_name: '',
      }
      this.form.car_cities.push(city)
    },
    removeCity(index){
      if(!this.form) return;
      if(!this.form.car_cities) return;
      this.form.car_cities = this.form.car_cities.filter((cityCity, cityCityIndex) => cityCityIndex != index);
    },
    submit() {
      this.allErrors = null;
      this.loading = true;

      if (this.$route.name === 'unit_registration_edit') {
        this.axios.patch('/units/'+this.$route.params.id, this.form)
            .then(() => {
              this.$router.push({name: 'unit_registration_list'});
              this.showSuccessMsg(this.$t('common.updateSuccess'))
            })
            .catch((err) => {
              this.allErrors = err.response.data.errors;
            })
            .finally(() => {
              this.loading = false;
            });
      } else {
        this.axios.post('/units', this.form)
            .then(() => {
              this.$router.push({name: 'unit_registration_list'});
              this.showSuccessMsg(this.$t('common.addSuccess'))
            })
            .catch((err) => {
              this.allErrors = err.response.data.errors;
            })
            .finally(() => {
              this.loading = false;
            });
      }
    }
  }
}
</script>
